import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./Home.css";

const Home = (props, context) => {
  return (
    <div className="home">
      {context.isSignedIn && (
        <div className="home-buttons">
          <Link className="home-button button-green" to="/solicitar">
            Solicitar
          </Link>
          <Link className="home-button button-green" to="/buscar">
            Transferir
          </Link>
        </div>
      )}
      <Link className="home-anchor" to={"/escanear"}>
        Escanee un código QR
      </Link>
    </div>
  );
};

Home.contextTypes = {
  isSignedIn: PropTypes.bool
};

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js